export default __webpack_public_path__ + "asset/img/icon-share-w~3cf3afae.png";